import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, map, throwError } from 'rxjs';
import { environment } from 'src/app/environments/environments';



@Injectable({
  providedIn: 'root'
})
export class GenericCrudService<T> {
  private apiUrl = environment.apiUrl;

  /*private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    }),
    body: {}
  };*/

  constructor(private http: HttpClient) { }

  crud<T>(body: any | FormData, EndPoint: string): Observable<T> {
    return this.http.post<T>(`${this.apiUrl}/${EndPoint}`, body).pipe(
      map((response: any) => {
        if (response.status === 0) {
          throw new Error(response.msg);
        }
        return response;
      }),
      catchError(error => {
        console.error('Ha ocurrido un error:');
        console.error(error);
        throw new Error('Ha ocurrido un error en la llamada al servicio.');
      })
    );

  }
}
